import { typePostsBlog } from './blog'
import { loadMoreBlogPosts } from './loadMoreItems'

function loadBlogPosts() {
    loadMoreBlogPosts(
        '#newsWrapper',
        'in-blog',
        '.news-item',
        'Zobrazit další',
        'Žádné další články nejsou k dispozici',
        'Další',
        'Předchozí',
        'strana'
    )
    typePostsBlog()
    $('#load-more-posts-button').insertAfter('.pagination-top')
}

export function initBlogListing() {
    loadBlogPosts()

    document.addEventListener('ShoptetDOMPageContentLoaded', () => {
        loadBlogPosts()
    })
}
